import { useQuery } from '@tanstack/react-query'

import { GetParametrosProposta } from '@/features/proposta/shared/http/get-parametros-proposta.service'
import { parametrosKeys } from '@/utils/parametros-query-keys'

export const useParametrosProposta = (idExternoEmpreendimento?: number) => {
  return useQuery({
    queryKey: parametrosKeys.proposta(idExternoEmpreendimento),
    queryFn: async () => new GetParametrosProposta().execute(String(idExternoEmpreendimento)).then((res) => res.data),
    enabled: !!idExternoEmpreendimento,
  })
}
